import { Service } from './service';
export abstract class LogBaseService extends Service {
  abstract logEvent(event: any);
  abstract logEventsAppraisalReview(events: any[], data, propertyId, loanId);
  abstract logEventInsuranceReview(events: any[], insuranceQuoteDataId);
  abstract logEvents(loanId: number, docType: string, events: any[]);
}
